import { create } from "zustand";

/** How long the "View" flash highlight stays armed (ms) — matches the CSS
 *  flash animation in globals.css. */
const FLASH_MS = 2500;

interface CalendarFocusState {
  /** When set, a calendar route should jump its anchor to this date (ISO). */
  anchorDate: string | null;
  /** Exact task/occurrence id, or a source id for a series-level flash. */
  highlightId: string | null;
  /** Jump the calendar to `date`, optionally flashing `taskId` (e.g. from a
   *  search result); omit the id for a plain day jump (Today's day headers). */
  focus: (date: Date, taskId?: string) => void;
  /** Consume the pending anchor jump (clears it so re-renders don't re-jump). */
  clearAnchor: () => void;
  clearHighlight: () => void;
}

let flashTimer: ReturnType<typeof setTimeout> | null = null;

export const useCalendarFocusStore = create<CalendarFocusState>((set) => ({
  anchorDate: null,
  highlightId: null,

  focus(date, taskId) {
    if (flashTimer) {
      clearTimeout(flashTimer);
      flashTimer = null;
    }
    set({ anchorDate: date.toISOString(), highlightId: taskId ?? null });
    if (taskId) {
      flashTimer = setTimeout(() => {
        flashTimer = null;
        set({ highlightId: null });
      }, FLASH_MS);
    }
  },

  clearAnchor() {
    set({ anchorDate: null });
  },

  clearHighlight() {
    if (flashTimer) clearTimeout(flashTimer);
    flashTimer = null;
    set({ highlightId: null });
  },
}));
